import icon_plus_white from "../../assets/images/icon_plus_white.svg";
import { Upload, Progress } from "antd";
import { useRef, useState } from "react";
import PopComponent from "../../pages/popContent";
import CustomModal from "../../hoc/CustomModal";
import icon_trash from '../../assets/images/icon_trash.svg';

const UploadTile = ({ value, className, grouplogo, handleChange, deleteLogoImage, name, error, handleError, progress, speClass, speTitle, ...rest }) => {
    const [errors, setError] = useState({});
    const [modalName, setModalName] = useState("UserInfo");
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);
    const uploadList = useRef(null);
    const handleUpload = (file) => {
        if (!file.type.match(/png|jpeg|jpg/g)) {
            handleOpenModal('ErrorPop', { header: "Info", body: 'Please add only png, jpg or jpeg files' })
            return Upload.LIST_IGNORE;
        } else {
            handleError({ target: { name } });
        }
    };
    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };

    return (
        <div className={`form_group ${className}`}>
            <div className="form_label">
                <label htmlFor="">{speTitle ? speTitle : "Course Cover Image *"}</label>
            </div>
            <div className={`form_input ${speClass ? speClass : "course_cover"}`}>{/**onChange={(e) => handleChange({ target: { file: e, type: "file", name } })} */}
                <Upload ref={uploadList} accept={rest?.accept} customRequest={(e) => { handleChange({ target: { file: e, type: "file", name } }) }} showUploadList={false} beforeUpload={handleUpload} className="sample_video_upload">
                    <div className="file_upload_btn">
                        <div className="file_upload">
                            {!value &&
                                <span>
                                    {
                                        uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent &&
                                            uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent !== 100 ?
                                            <Progress width={50} showInfo={false} type="circle" percent={uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent} /> :
                                            <img src={icon_plus_white} alt="" className="default_plus_icon" />
                                    }
                                </span>
                            }
                            {
                                uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent &&
                                    uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent !== 100 && value ?
                                    <div className="sample_video_thumb">
                                        <span className="uploaded_thumb_img cursor_pointer">
                                            <Progress width={50} showInfo={false} type="circle" percent={uploadList?.current?.fileList?.[uploadList.current.fileList?.length - 1]?.percent} />
                                        </span>
                                    </div> :
                                    value && (
                                        <div className="sample_video_thumb">
                                            <span className="uploaded_thumb_img cursor_pointer">
                                                <img src={value} alt="Video thumb" className="img_fluid img_object_center radius_5" />
                                            </span>
                                        </div>
                                    )
                            }
                        </div>
                    </div>
                </Upload>
                {grouplogo && <span className="upload_logo_video" onClick={deleteLogoImage}><img src={icon_trash} alt="Trash icon" height="14" /></span>}
                <p className="errMsg">{error}</p>
            </div>
            {
                Modal && (
                    <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                        <Modal
                            error={errors}
                            handleOpenModal={handleOpenModal}
                        />
                    </CustomModal>
                )
            }
        </div>
    )
};

export default UploadTile